import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useGetPreviewCustomizationSettingsUrl } from 'crm-links/layoutEditor/useGetPreviewCustomizationSettingsUrl';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { jsx as _jsx } from "react/jsx-runtime";
function trackPreviewCustomization() {
  CrmLogger.log('recordInteractions', {
    action: 'choose link under record actions menu',
    subAction: undefined,
    objectType: PRODUCT_TYPE_ID
  });
}
function ProductHighlightCustomizePreview({
  hasScope,
  hasGate
}) {
  const isUngatedToPreviewCustomization = hasGate('CRM:PageEditor:PreviewSidebarCustomization');
  const isCrmPageEditorAdmin = hasScope('crm-page-editor-admin');
  const previewCustomizationSettingsUrl = useGetPreviewCustomizationSettingsUrl(PRODUCT_TYPE_ID);
  if (!isUngatedToPreviewCustomization || !isCrmPageEditorAdmin || !previewCustomizationSettingsUrl) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIButton, {
    use: "link",
    target: "_blank",
    external: true,
    href: previewCustomizationSettingsUrl,
    onClick: trackPreviewCustomization,
    "data-test-id": "customize-preview-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "actions.customizePreview"
    })
  });
}
export default ProductHighlightCustomizePreview;